module.exports = __webpack_public_path__ + "static/media/Modelo_Destaque Atvos_Crescimento Sustentável.7e4905e3.docx";